import React from 'react';

import BaseButton from 'features/app/components/BaseButton';
import { useStyles } from './styles';

export type TableColorScheme = 'failed' | 'processing' | 'success';

interface TableItemStatusProps {
  colorScheme: TableColorScheme;
}

export const TableItemStatus: React.FC<TableItemStatusProps> = ({ children, colorScheme }) => {
  const classes = useStyles();

  return (
    <BaseButton variant="outlined" className={`${classes.container} ${classes[colorScheme]}`} labelClass={classes.label}>
      {children}
    </BaseButton>
  );
};
